/* eslint complexity: ["error", {max: 9}] -- this applies for the entire file */

import isNil from "lodash/isNil";

import { isUserInTreatment } from "@/hooks/usePatientStatus";

type GetCareTeamPropsParams = {
  isAppUser: boolean;
  isAppUserInTreatment?: boolean;
  isAppUserPatient: boolean;
  proxyPatients?: LinkedPatientProfile[];
  selectedUserId: string;
};

export const getCareTeamProps = ({
  isAppUser,
  isAppUserInTreatment,
  isAppUserPatient,
  proxyPatients,
  selectedUserId,
}: GetCareTeamPropsParams) => {
  if (isAppUser && isAppUserPatient) {
    return {
      careTeamPatientId: selectedUserId,
      shouldShowProviderCarousel: Boolean(isAppUserInTreatment),
    };
  }

  const hasOnlyOnePatient = isAppUser && proxyPatients?.length === 1;
  const careTeamPatientId = hasOnlyOnePatient
    ? proxyPatients[0].externalId
    : selectedUserId;
  const universalStatusCode = proxyPatients?.find(
    (p: LinkedPatientProfile) => p.externalId === careTeamPatientId,
  )?.universalStatusCode;
  const shouldShowProviderCarousel =
    !isNil(universalStatusCode) && isUserInTreatment(universalStatusCode);

  // only situations in which the care team is shown:
  //  1) app user is selected,
  //     app user has only 1 linked patient,
  //     that 1 linked patient is in treatment or paused
  //  2) app user is selected,
  //     app user is in treatment or paused
  //  3) a DIFFERENT user is selected,
  //     selected user is in treatment or paused
  return {
    careTeamPatientId,
    shouldShowProviderCarousel,
  };
};
